<pershing-responsive [small]="smallRef" [medium]="mediumRef" [large]="largeRef" [respondToWindow]="true">
</pershing-responsive>

<ng-template #largeRef>
    <div class="as-Settings large-container">
        <ng-template [ngTemplateOutlet]="settingsPageTemplate">
        </ng-template>
    </div>
</ng-template>

<ng-template #mediumRef>
    <div class="as-Settings medium-container">
        <ng-template [ngTemplateOutlet]="settingsPageTemplate">
        </ng-template>
    </div>
</ng-template>

<ng-template #smallRef>
    <div class="as-Settings small-container">
        <ng-template [ngTemplateOutlet]="settingsPageTemplate">
        </ng-template>
    </div>
</ng-template>

<ng-template #settingsPageTemplate>
    <ng-container *ngFor="let tile of allsettings">
        <mat-card id="{{tile.id}}" class="as-Settings_Tile" *ngIf="tile.isEntitled" (click)="navigateToPage(tile)" (keyup.enter)="navigateToPage(tile)" tabindex="0" role="link" attr.aria-label="{{ 'NXI_NAVIGATION.LINK_TO' | translate}} {{ tile.title | translate}}">
            <div class="as-Settings_Tile-{{tile.id}}"></div>
            <h2 class="as-Settings_Tile-Title">{{ tile.title | translate}}</h2>
            <p class="as-Settings_Tile-Description">
                {{ tile.description | translate }}</p>
        </mat-card>
    </ng-container>
</ng-template>